export const first_name_validation = {
    name: 'FirstName',
    label: 'First Name',
    type: 'text',
    id: 'FirstName',
    placeholder: 'Write your first name ...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
        maxLength: {
            value: 30,
            message: '30 characters max',
        },
    },
};

export const username_validation = {
    name: 'Username',
    label: 'User name',
    type: 'email',
    id: 'email',
    placeholder: 'Write user name ...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
        pattern: {
            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Not a valid email',
        },
    },
};

export const last_name_validation = {
    name: 'LastName',
    label: 'Last Name',
    type: 'text',
    id: 'LastName',
    placeholder: 'Write your last name ...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
        maxLength: {
            value: 30,
            message: '30 characters max',
        },
    },
};

export const password_validation = {
    name: 'Password',
    label: 'Password',
    type: 'password',
    id: 'password',
    placeholder: 'Password ...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
        minLength: {
            value: 6,
            message: 'Min 6 characters',
        },
        pattern: {
            value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
            message: 'Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character',
        },
    },
};

export const confirm_password_validation = {
    name: 'ConfirmPassword',
    label: 'Confirm Password',
    type: 'password',
    id: 'confirmPassword',
    placeholder: 'Confirm password ...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
        minLength: {
            value: 6,
            message: 'Min 6 characters',
        },
        pattern: {
            value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
            message: 'Password must contain at least one lowercase letter, one uppercase letter, one number, and one special character',
        },
    },
};

export const num_validation = {
    name: 'MobileNumber',
    label: 'Mobile Number',
    type: 'number',
    id: 'mobileNumber',
    placeholder: 'Write a mobile number...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
    },
};

export const email_validation = {
    name: 'Email',
    label: 'Email address',
    type: 'email',
    id: 'email',
    placeholder: 'Write an email address ...',
    validation: {
        required: {
            value: true,
            message: 'Required',
        },
        pattern: {
            value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Not a valid email',
        },
    },
};

export const role_options = {
    name: 'role',
    label: 'Role',
    id: 'role',
    placeholder: 'Select your role',
    validation: { required: 'Required' },
    options: [
        { value: 2, label: 'Teacher' },
        { value: 3, label: 'Student' },
    ],
};
